import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ErrorSubtitleText = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${40 * Screen.widthRatio}px;
  margin-top: ${50 * Screen.widthRatio}px;
  margin-left: ${200 * Screen.widthRatio}px;
  margin-right: ${200 * Screen.widthRatio}px;
  text-align: center;
`;

export default ErrorSubtitleText;
